import { useState } from 'react';
import { Link } from 'react-router-dom';
import { LogIn, Briefcase } from 'lucide-react';
import LeadForm from '../../components/LeadForm';

export default function ForProfessionals() {
  const [leadFormOpen, setLeadFormOpen] = useState(false);

  return (
    <div className="bg-surface min-h-screen">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <p className="text-accent text-sm font-semibold tracking-wide uppercase">
            For Professionals
          </p>
          <h1 className="text-fg mt-2 text-4xl font-extrabold tracking-tight sm:text-5xl">
            Grow Your Business with Calendyz
          </h1>
          <p className="text-fg-muted mx-auto mt-4 max-w-2xl text-xl">
            Join our platform to reach new clients, manage appointments, and streamline your salon
            operations.
          </p>
        </div>

        <div className="mx-auto grid max-w-4xl grid-cols-1 gap-8 md:grid-cols-2">
          {/* Sign In Card */}
          <div className="border-default flex flex-col items-center rounded-2xl border p-8 text-center shadow-sm">
            <div className="bg-muted mb-6 flex h-14 w-14 items-center justify-center rounded-full">
              <LogIn className="text-accent h-7 w-7" />
            </div>
            <h2 className="text-fg text-xl font-bold">Sign In</h2>
            <p className="text-fg-muted mt-2">
              Already a partner? Access your admin dashboard to manage appointments and services.
            </p>
            <Link
              to="/admin"
              className="bg-brand-600 hover:bg-brand-700 mt-6 inline-flex items-center rounded-lg px-6 py-3 font-medium text-white transition-colors"
            >
              Go to Dashboard
            </Link>
          </div>

          {/* Get Started Card */}
          <div className="border-default flex flex-col items-center rounded-2xl border p-8 text-center shadow-sm">
            <div className="bg-muted mb-6 flex h-14 w-14 items-center justify-center rounded-full">
              <Briefcase className="text-accent h-7 w-7" />
            </div>
            <h2 className="text-fg text-xl font-bold">Get Started</h2>
            <p className="text-fg-muted mt-2">
              New to Calendyz? Get in touch and we'll help you set up your salon profile.
            </p>
            <a
              href="mailto:support@calendyz.com"
              className="text-fg-subtle hover:text-fg-secondary mt-3 text-sm underline-offset-2 hover:underline"
            >
              support@calendyz.com
            </a>
            <button
              type="button"
              onClick={() => setLeadFormOpen(true)}
              className="border-strong text-fg-secondary hover:bg-canvas mt-4 inline-flex items-center rounded-lg border px-6 py-3 font-medium transition-colors"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>

      <LeadForm open={leadFormOpen} onClose={() => setLeadFormOpen(false)} />
    </div>
  );
}
